import React from "react";
import { Stack, Box, Text } from "@origin-digital/ods-core";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import EditButton from "./EditButton";
import { getFullName } from "../ChangeRequest/helpers";

interface ReadOnlyBusinessPrimaryContactProps {
  firstName: string;
  lastName: string;
  dateOfBirth: Date | null;
  phone: string;
  email: string;
  formatDate: (date: Date | null) => string;
  onEdit?: () => void;
}

const ReadOnlyBusinessPrimaryContact: React.FC<
  ReadOnlyBusinessPrimaryContactProps
> = ({
  firstName,
  lastName,
  dateOfBirth,
  phone,
  email,
  formatDate,
  onEdit,
}) => (
  <Stack>
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Text weight="medium" tone="neutralDark">
        Primary contact
      </Text>
      {onEdit ? <EditButton onClick={onEdit} /> : null}
    </Box>
    <Stack>
      {/* Name */}
      <ReadOnlyTextField
        label="Name"
        value={getFullName(firstName, lastName)}
      />
      {/* End Name */}
      {/* DOB + Phone */}
      <Box
        display="flex"
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        {/* Date of birth */}
        <ReadOnlyTextField
          label="Date of birth"
          value={formatDate(dateOfBirth)}
        />
        {/* End Date of birth */}
        {/* Phone */}
        <ReadOnlyTextField label="Phone" value={phone} />
        {/* End Phone */}
      </Box>
      {/* End DOB + Phone */}
      {/* Email */}
      <ReadOnlyTextField label="Email" value={email} />
      {/* End Email */}
    </Stack>
  </Stack>
);

export default ReadOnlyBusinessPrimaryContact;
